import React, { Component, createRef } from "react";

import {
  CCol,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CPagination
} from "@coreui/react";
import { Switch } from "@material-ui/core";
import {
  EllipsisVertical,
  Copy,
  Star,
  Heart,
  HeartOff,
  FileText
} from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import DefaultDiscipline from "../../assets/imgs/disciplines/default.PNG";
import URL from "../../config/api";
import axios from "../../config/axios";
import { ContentCard } from "../ContentCard";
import Loading from "../Loading";
import "./styles.css";

class ContentLessonPlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selected: [],
      filters: {},
      modal: false,
      modalOrder: false,
      content: [],
      favorites: [],
      favoritesFilter: false,
      contentList: {
        type: null,
        list: []
      },
      segments: [],
      filter: {
        word: this.props?.word === "" ? null : this.props.word,
        segment: { value: null, label: "Todos" },
        discipline: { value: null, label: "Todos" },
        serie: { value: null, label: "Todas" },
        module: { value: null, label: "Todos" },
        ability: { value: null, label: "Todos" }
      },
      advancedSearchFilters: [
        { filterName: "Nome", check: true },
        { filterName: "Resumo", check: true },
        { filterName: "Componente curricular", check: true },
        { filterName: "Habilidades BNCC", check: true }
      ],
      type: Number(this.props.type),
      ability_filter: false,
      maxItems: 16,
      currentPage: 1,
      maxPages: 1,
      itemsCount: 0
    };
    this.timeToUpdate = createRef(3);
    this.countdown = null;
  }

  hasBNCCFilter = () => {
    const groupsWithoutBNCC = [71];
    return !groupsWithoutBNCC.includes(
      this.props.general.active_roles.group_id
    );
  };

  componentDidMount() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    (async () => {
      await this.pullData();
      await this.getFavorites();
    })();
  }

  Input(inputProps) {
    <components.Input {...inputProps} autoComplete="nope" />;
  }

  pullData = async () => {
    axios
      .get(
        `${URL.api}content/los/filterStructureObjective/${this.state.type}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(resp => {
        const losCachedFilters = localStorage.getItem(
          `losFilter@${this.props.currentRoute}`
        );

        let filter = losCachedFilters
          ? JSON.parse(losCachedFilters)
          : {
              word: this.props?.word === "" ? null : this.props.word,
              segment: { value: null, label: "Todos" },
              discipline: { value: null, label: "Todos" },
              serie: { value: null, label: "Todas" },
              module: { value: null, label: "Todos" },
              ability: { value: null, label: "Todos" }
            };

        delete filter.word;

        if (this.props.serie) {
          const segment = resp.data.data.find(item =>
            item.series.find(serie => serie.id === parseInt(this.props.serie))
          );
          const serie = segment.series.find(
            serie => serie.id === parseInt(this.props.serie)
          );

          if (segment) {
            filter.segment = { value: segment.id, label: segment.name };
          }

          if (serie) {
            filter.serie = {
              value: serie.id,
              label: serie.name
            };
          }
        }

        if (this.props.discipline) {
          const segment = resp.data.data.find(item =>
            item.series.find(serie =>
              serie.disciplines.find(
                discipline => discipline.id === parseInt(this.props.discipline)
              )
            )
          );
          const serie = segment.series.find(serie =>
            serie.disciplines.find(
              discipline => discipline.id === parseInt(this.props.discipline)
            )
          );
          const discipline = serie.disciplines.find(
            discipline => discipline.id === parseInt(this.props.discipline)
          );

          if (discipline) {
            filter.discipline = {
              value: discipline.id,
              label: discipline.name
            };
          }
        }

        this.setState(
          {
            segments: resp.data.data,
            filter,
            filters: filter
          },
          () => {
            this.setType();
          }
        );

        if (this.props.isOfflineRegister && this.props.disciplineSelected) {
          // eslint-disable-next-line react/no-access-state-in-setstate
          let newFilter = this.state.filter;
          newFilter.discipline = this.props.disciplineSelected;
          this.setState({ filter: newFilter });
        }
      });
  };

  getFavorites = async () => {
    await axios
      .get(`${URL.api}content/favorites/list`, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(resp => {
        const favorites = resp.data.data.map(favorite => favorite.lo_id);

        this.setState({ favorites });
      });
  };

  insertFavorite = async id => {
    await axios
      .post(
        `${URL.api}content/favorites/insert`,
        { lo_id: id },
        {
          headers: {
            authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(() => {
        this.setState(prevState => ({
          favorites: [...prevState.favorites, id]
        }));
      });
  };

  deleteFavorite = async id => {
    await axios
      .delete(`${URL.api}content/favorites/deleteByLoId/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(() => {
        this.setState(prevState => ({
          favorites: prevState.favorites.filter(favorite => favorite !== id)
        }));
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.filter.word !== prevState.filter.word &&
      (this.state.filter.word === "" || !this.state.filter.word)
    ) {
      this.filter(this.state.filter);
    }
  }

  takeContentSelected = (elem, contentId) => {
    if (elem.current) {
      const elemString =
        elem.current.getElementsByClassName("contentTitle")[0].innerText;
      this.props.addContent(elemString, contentId);
      this.props.hideModal(true);
    }
  };

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  };

  toggleModalOrder = () => {
    this.setState(prevState => ({ modalOrder: !prevState.modalOrder }));
  };

  setType = () => {
    const filter = this.props.general.filtered_content;
    let { type } = this.state;

    if (filter) {
      type = filter.type;
    }

    if (type !== 0) {
      this.setState(
        {
          filters: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.filters,
            // eslint-disable-next-line react/no-access-state-in-setstate
            type: this.state.type
          }
        },
        () => {
          this.getLos();
          if (this.props.activity) {
            // this.setState({ activity: true });
          }
        }
      );
    } else {
      this.getLos();
    }
  };

  changeInputName = e => {
    clearInterval(this.countdown);
    this.changeFilter("word", e.target.value);

    this.timeToUpdate.current = 3;

    this.countDown = setInterval(() => {
      this.timeToUpdate.current -= 1;

      if (this.timeToUpdate.current === 0) {
        clearInterval(this.countdown);
        this.filter(this.state.filter);
      }
    }, 1000);
  };

  getLos = async () => {
    this.setState({ loading: true });

    const filters = {
      type: 34,
      word: this.state.filters.word,
      segment: this.state.filters.segment && this.state.filters.segment.value,
      discipline:
        this.state.filters.discipline && this.state.filters.discipline.value,
      serie: this.state.filters.serie && this.state.filters.serie.value,
      module: null,
      ability: null,
      content: null,
      private: !!this.props.libraryMode,
      favorites: this.state.favoritesFilter
    };

    try {
      const resp = await axios.post(
        `${URL.api}content/los/listLosFilter?page=${
          // eslint-disable-next-line react/no-access-state-in-setstate
          this.state.currentPage
          // eslint-disable-next-line react/no-access-state-in-setstate
        }&page_size=${this.state.maxItems}${
          this.props.libraryMode ? "&libraryMode=true" : ""
        }`,
        filters,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );
      if (!resp.data.data[0]) {
        this.handleAdvancedFilters([]);
      }

      let respostaOrdenada = resp.data.data[0]?.content;
      respostaOrdenada?.sort((a, b) => b.id - a.id);

      resp.data.data[0].content = respostaOrdenada;
      this.handleAdvancedFilters(resp.data.data);
      this.setState({
        currentPage: resp.data.meta.current_page,
        maxPages: resp.data.meta.last_page,
        itemsCount: resp.data.meta.total
      });
    } catch (error) {
      this.setState({ itemsCount: 0, loading: false });
    }
  };

  handleAdvancedFilters = preFilteredBatches => {
    const wordFilter = this.state.filter.word?.toLowerCase();
    const activeFilters = this.state.advancedSearchFilters;
    const filteredBatch = preFilteredBatches.slice();

    if (!wordFilter || wordFilter === "") {
      this.setState({ content: preFilteredBatches, currentPage: 1 }, () => {
        this.setState({ loading: false });
      });
      return;
    }

    filteredBatch.forEach(batch => {
      const filteredLos = batch.content.filter(
        content =>
          (activeFilters[0].check &&
            content.name.toLowerCase().includes(wordFilter)) ||
          (activeFilters[1].check &&
            content.resume.toLowerCase().includes(wordFilter)) ||
          (activeFilters[2].check &&
            content.discipline_name.toLowerCase().includes(wordFilter)) ||
          (activeFilters[3].check &&
            content.ability_description?.toLowerCase().includes(wordFilter))
      );

      batch.content = filteredLos;
    });

    this.setState({ content: filteredBatch, currentPage: 1 }, () => {
      this.setState({ loading: false });
    });
  };

  fitered = filters => {
    if (this.state.filters.type) {
      filters.type = this.state.filters.type;
    }

    this.setState({ filters }, () => {
      this.getLos();
    });
  };

  getSelected = select => {
    let { selected } = this.state;

    if (selected.length > 0) {
      selected.forEach((item, idx) => {
        if (item.id === select.id) {
          selected.splice(idx, 1);
        }
      });
    }

    selected.push(select);

    this.setState({ selected }, () => {
      let list = [];
      let { selected } = this.state;

      if (this.state.type === "0") {
        selected.forEach(lesson => {
          lesson.slides.forEach(slide => {
            if (slide.checked) {
              slide.father = lesson.id;
              list.push(slide);
            }
          });
        });
      } else {
        list = this.state.contentList.list;
        if (list.length > 0) {
          list.forEach((content, idx) => {
            if (content.id === select.id) {
              list.splice(idx, 1);
            } else {
              list.push(select);
            }
          });
        } else {
          list.push(select);
        }
      }

      this.setState({
        contentList: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          type: this.state.content[0].id,
          list
        }
      });
    });
  };

  getOrder = (list, where) => {
    this.setState(
      {
        contentList: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          type: this.state.content[0].id,
          list
        }
      },
      () => {
        this.finalize();
      }
    );
  };

  checked = item => {
    this.selectSlide(item);
    let { selectedLessons } = this.state;
    if (selectedLessons.length === 0) {
      selectedLessons.push(item);
    } else {
      selectedLessons.forEach((selected, idx) => {
        if (item.id === selected.id) {
          selectedLessons.splice(idx, 1);
        } else {
          selectedLessons.push(item);
        }
      });
    }
    this.setState(
      {
        selectedLessons
      },
      () => {
        this.finalize();
      }
    );
  };

  finalize = () => {
    // TODO fn para salvar as escolhas
    // this.props.getSelected(this.state.slideList)
  };

  send = () => {
    this.props.getContent(this.state.contentList);
  };

  filter(filters) {
    this.setState({ filters }, () => {
      this.getLos();
    });
  }

  changeFilter(prop, value) {
    this.setState(
      state => {
        let filter = { ...state.filter };
        filter[prop] = value;

        if (prop === "segment") {
          filter.serie = { value: null, label: "Todas" };
          filter.discipline = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "serie") {
          filter.discipline = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "discipline") {
          filter.ability = { value: null, label: "Todos" };
        }

        let segments = [...state.segments];

        localStorage.setItem(
          `losFilter@${this.props.currentRoute}`,
          JSON.stringify(filter)
        );

        return { segments, filter, filters: filter };
      },
      () => {
        if (prop !== "word") {
          this.filter(this.state.filter);
        }
      }
    );
  }

  toggleAdvancedFiltersValues = filterToToggle => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const newFilters = this.state.advancedSearchFilters;
    const changedFilter = this.state.advancedSearchFilters.findIndex(
      item => item.filterName === filterToToggle
    );
    newFilters[changedFilter].check = !newFilters[changedFilter].check;

    this.setState({ advancedSearchFilters: newFilters });
  };

  handleCopyAction = content => {
    const url = window.location.href.split("/");
    const title = content.name.replace(/ /g, "%18");
    navigator.clipboard.writeText(
      `${url[0]}//${url[2]}/lessonPlan/${content.lesson_plan_id}`
    );
    toastr.success(
      "Link copiado",
      "O link do conteúdo foi copiado para a área de transferência"
    );
  };

  handleOpenPDF = content => {
    window.open(content.pdf_path, "_blank");
  };

  formatSeries = content => {
    if (!content.series || content.series.length === 0) return "";
    if (content.series.length === 1) return `${content.serie_name}`;
    if (content.series.length === 2) {
      return `${content.series[0].name} e ${content.series[1].name}`;
    }

    return (
      <div className="d-flex align-items-center">
        {`${content.series[0].name}, ${content.series[1].name} e `}
        <u
          title={content.series.map(serie => serie.name).join(", ")}
          className="ml-1"
        >
          mais...
        </u>
      </div>
    );
  };

  checkIfContentIsNew = content => {
    const today = new Date();
    const contentDate = new Date(content.updated_at);
    const diffTime = Math.abs(today - contentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays < 30;
  };

  render() {
    let img = "";
    if (this.state.filters.disciplines) {
      let discipline = this.state.filters.disciplines[0];
      img = DefaultDiscipline;
      if (discipline.symbol != null) {
        img = discipline.symbol;
      }
    }

    const filter = {
      word: this.state.filters.word,
      segment:
        this.state.filters.segment &&
        this.state.filters.segment.value &&
        this.state.filters.segment.label,
      discipline:
        this.state.filters.discipline &&
        this.state.filters.discipline.value &&
        this.state.filters.discipline.label,
      serie:
        this.state.filters.serie &&
        this.state.filters.serie.value &&
        this.state.filters.serie.label,
      module:
        this.state.filters.module &&
        this.state.filters.module.value &&
        this.state.filters.module.label,
      ability:
        this.state.filters.ability &&
        this.state.filters.ability.value &&
        this.state.filters.ability.label
    };

    let segments = this.state.segments
      .sort((a, b) => a.order - b.order)
      .map(segment => ({
        value: segment.id,
        label: segment.name,
        series: segment.series
      }));
    let series = [];
    let disciplines = [];
    let modules = [];

    if (this.state.filter.segment?.value) {
      series = segments
        .filter(segment => segment.value === this.state.filter.segment.value)
        .reduce((acc, val) => [...acc, ...val.series], [])
        .sort((a, b) => a.order - b.order)
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    } else {
      series = segments
        .reduce(
          (acc, val) => [
            ...acc,
            ...val.series.map(item => ({ ...item, segment_id: val.value }))
          ],
          []
        )
        .sort(
          (a, b) =>
            a.segment_id * 100 + a.order - (b.segment_id * 100 + b.order)
        )
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    }

    if (this.state.filter.serie?.value) {
      disciplines = series
        .filter(serie => serie.value === this.state.filter.serie.value)
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    } else {
      disciplines = series
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    }

    if (this.state.filter.discipline?.value) {
      modules = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));
    } else {
      modules = disciplines
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));
    }

    segments = [
      { value: null, label: "Todos" },
      ...segments.filter(
        (segment, index) =>
          segments.findIndex(item => item.value === segment.value) === index
      )
    ];
    series = [
      { value: null, label: "Todas" },
      ...series.filter(
        (serie, index) =>
          series.findIndex(item => item.value === serie.value) === index
      )
    ];
    disciplines = [
      { value: null, label: "Todos" },
      ...disciplines.filter(
        (discipline, index) =>
          disciplines.findIndex(item => item.value === discipline.value) ===
          index
      )
    ];
    modules = [
      { value: null, label: "Todos" },
      ...modules.filter(
        (module, index) =>
          modules.findIndex(item => item.id === module.id) === index
      )
    ];

    const content = this.state.content.reduce(
      (acc, val) => [
        ...acc,
        ...val.content.map(item => ({ ...item, type_id: val.id }))
      ],
      []
    );

    return (
      <div>
        <div className="row align-items-center mb-2">
          {this.hasBNCCFilter() && (
            <div className="col-12 col-sm-6">
              <h2>Planos de Aula</h2>
              {/* <p className="text-muted">Encontre o que você precisa aqui.</p> */}
            </div>
          )}
          <InputGroup className="col-12 col-sm-6">
            <InputGroupAddon addonType="prepend">
              <InputGroupText className="bg-white pr-1">
                <i className="fa fa-search text-muted"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Pesquisar"
              onChange={this.changeInputName}
              value={this.state.filter.word}
              id="searchInput"
              type="search"
              autoComplete="off"
            />
          </InputGroup>
        </div>
        <div className="row">
          <div className="col-4 col-md-3 mb-4">
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Segmento</Label>
            </div>
            <InputGroup>
              <Select
                placeholder="Segmento"
                onChange={e => this.changeFilter("segment", e)}
                value={this.state.filter.segment}
                options={segments}
              />
            </InputGroup>
          </div>
          <div className="col-4 col-md-3 mb-4">
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">Série</Label>
            </div>
            <InputGroup>
              <Select
                placeholder="Série"
                onChange={e => this.changeFilter("serie", e)}
                value={this.state.filter.serie}
                options={series}
              />
            </InputGroup>
          </div>
          <div className="col-6 col-md-3 mb-4">
            <div className="w-100 text-ellipsis">
              <Label className="d-block w-100 text-ellipsis">
                Componente curricular
              </Label>
            </div>
            <InputGroup>
              <Select
                placeholder="Componente curricular"
                onChange={e => this.changeFilter("discipline", e)}
                value={this.state.filter.discipline}
                options={disciplines}
              />
            </InputGroup>
          </div>
          {this.hasBNCCFilter() && (
            <div className="col-6 col-md-3 mb-4">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">
                  Eixo temático
                </Label>
              </div>
              <InputGroup>
                <Select
                  placeholder="Eixo temático BNCC"
                  key={this.state.ability_filter}
                  onChange={e => this.changeFilter("module", e)}
                  value={this.state.filter.module}
                  options={modules}
                />
              </InputGroup>
            </div>
          )}
        </div>
        <div className="w-full d-flex justify-content-between align-items-center mb-3 row sm-row-reverse">
          <div className="col-6 mt-2">
            <span className="m-0">
              Exibindo resultado da busca para{" "}
              {this.state.filter.discipline.label === "Todos"
                ? `todas as disciplinas ${
                    this.state.filter.serie.label === "Todas" ? "de " : ""
                  }`
                : `${this.state.filter.discipline.label} `}
              {this.state.filter.serie.label === "Todas"
                ? `${
                    this.state.filter.discipline.label !== "Todos" ? "de " : ""
                  } todas as séries`
                : `do ${this.state.filter.serie.label}`}
              , altere os filtros para mais resultados.
            </span>
          </div>
          <div
            className="d-flex align-items-center mt-2"
            style={{
              backgroundColor: "#e0e0e0",
              paddingLeft: 20,
              paddingRight: 8,
              borderRadius: 50
            }}
            onClick={() => {
              this.setState(
                prevState => ({
                  favoritesFilter: !prevState.favoritesFilter
                }),
                () => this.getLos()
              );
            }}
          >
            <Label className="p-0 m-0">Meus Favoritos</Label>
            <Switch
              color="info"
              className="m-0"
              checked={this.state.favoritesFilter}
            ></Switch>
          </div>
        </div>
        <div>
          {this.state.loading ? (
            <Loading />
          ) : this.state.content.length > 0 ? (
            <div>
              <div className="contentArea row">
                {content.map((content, idx) => {
                  const favorite = this.state.favorites.includes(content.id);
                  return (
                    <CCol xs="6" md="6" lg="4" xl="3" key={`type-${idx}`}>
                      <ContentCard.Root
                        titleLink={`/lessonPlan/${content.lesson_plan_id}`}
                      >
                        <ContentCard.Banner
                          fallbackColor={
                            this.props.types?.find(
                              item => item.id === content.type_id
                            )?.color
                          }
                          fallbackIcon={
                            this.props.types?.find(
                              item => item.id === content.type_id
                            ).icon
                          }
                          badge={this.checkIfContentIsNew(content) && "Novo"}
                          image={content.image}
                        />
                        <ContentCard.Main>
                          <ContentCard.Header title={content.name}>
                            <ContentCard.Item>
                              <p className="text-muted">
                                {content.discipline_name}
                                {content.ability_code &&
                                  ` • (${content.ability_code})`}
                              </p>
                            </ContentCard.Item>
                          </ContentCard.Header>
                        </ContentCard.Main>
                      </ContentCard.Root>
                      <CDropdown className="context">
                        <CDropdownToggle
                          caret={false}
                          className="contextToggle rounded-circle btn-sm p-3"
                        >
                          <EllipsisVertical size={18} />
                        </CDropdownToggle>
                        <CDropdownMenu placement="top-end">
                          <CDropdownItem
                            className="text-dark"
                            onClick={() => {
                              if (favorite) {
                                this.deleteFavorite(content.id);
                              } else {
                                this.insertFavorite(content.id);
                              }
                            }}
                          >
                            {favorite ? (
                              <HeartOff size={18} className="mr-2" />
                            ) : (
                              <Heart size={18} className="mr-2" />
                            )}

                            {favorite
                              ? "Remover dos favoritos"
                              : "Adicionar aos favoritos"}
                          </CDropdownItem>
                          <hr />
                          <CDropdownItem
                            className="text-dark"
                            onClick={() => {
                              this.handleCopyAction(content);
                            }}
                          >
                            <Copy size={18} className="mr-2" />
                            Copiar link
                          </CDropdownItem>
                          {content.pdf_path && (
                            <CDropdownItem
                              className="text-dark"
                              onClick={() => {
                                this.handleOpenPDF(content);
                              }}
                            >
                              <FileText size={18} className="mr-2" />
                              Baixar livro digital
                            </CDropdownItem>
                          )}
                        </CDropdownMenu>
                      </CDropdown>
                    </CCol>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="text-muted p-4 d-flex justify-content-center">
              Nenhum conteúdo encontrado
            </div>
          )}
        </div>
        <div className="d-flex row mt-4">
          <div className="col-4 text-muted">
            <span>Total: {this.state.itemsCount}</span>
          </div>
          <div className="col-8 col-md-8 col-sm-2 d-flex justify-content-end">
            <CPagination
              activePage={this.state.currentPage}
              pages={this.state.maxPages}
              onActivePageChange={page =>
                this.setState({ currentPage: page }, () => this.getLos())
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentLessonPlans);
